export const translations = {
  it: {
    nav: {
      about: "Chi siamo",
      services: "Servizi",
      brands: "Realtà",
      team: "Team",
      contact: "Contatti",
    },
    hero: {
      eyebrow: "PROSCENIO SOLUTIONS",
      title: "Un palcoscenico di soluzioni.",
      subtitle:
        "Musica, informatica e didattica — un'unica regia artistica al servizio di eventi, progetti e persone nelle province di Ferrara e Rovigo.",
      cta_primary: "Scopri i servizi",
      cta_secondary: "Contattaci",
      scroll: "Scroll",
    },
    marquee: ["Musica", "Informatica", "Didattica", "Concerti", "Matrimoni", "SPID", "Formazione"],
    about: {
      kicker: "Chi siamo",
      title: "Proscenio Solutions di Stefano Ongaro",
      body1:
        "Attività leader nelle province di Ferrara e Rovigo, attribuiamo la nostra reputazione al rapporto di fiducia che da anni instauriamo con i nostri clienti. Crediamo che ognuno dei nostri clienti meriti servizi di alto livello, ed è proprio questo che vogliamo offrire.",
      body2:
        "Il titolare, Stefano Ongaro, è docente e musicista con un'esperienza pluridecennale; è perito informatico abilitato e incaricato alla verifica dell'identità personale dei cittadini che vogliano dotarsi di SPID.",
      stat1_value: "20+",
      stat1_label: "Anni di esperienza",
      stat2_value: "2",
      stat2_label: "Realtà artistiche",
      stat3_value: "3",
      stat3_label: "Ambiti di servizio",
    },
    pillars: {
      kicker: "I nostri ambiti",
      title: "Tre anime, un'unica cura.",
      music: {
        name: "Musica",
        desc: "Organizzazione concerti, direzione artistica e promozione di formazioni musicali per eventi, manifestazioni e cerimonie.",
        tags: ["Concerti", "Direzione artistica", "Cerimonie"],
      },
      it: {
        name: "Informatica",
        desc: "Assistenza informatica, consulenza e attivazione dell'identità digitale SPID con operatore abilitato.",
        tags: ["Assistenza", "SPID", "Identità digitale"],
      },
      education: {
        name: "Didattica",
        desc: "Progetti di didattica musicale e recupero materie scolastiche, con attenzione speciale ad alunni DSA e BES.",
        tags: ["Didattica musicale", "Recupero", "DSA / BES"],
      },
    },
    brands: {
      kicker: "Le nostre realtà",
      title: "Curati da Proscenio Solutions.",
      wedding: {
        name: "Proscenio Wedding",
        role: "Cerimonie & ricevimenti",
        desc: "L'aspetto musicale di eventi di ogni genere: matrimoni religiosi e civili, banchetti, ricevimenti. Formazioni dal solista all'orchestra, scelte su misura con i nostri music planner.",
        cta: "Scopri Wedding",
      },
      ensemble: {
        name: "Proscenio Ensemble",
        role: "Formazione da concerto",
        desc: "La nostra formazione da concerto, curata artisticamente da Stefano Ongaro. Repertorio che spazia dal classico al contemporaneo, con un'identità teatrale riconoscibile.",
        cta: "Scopri Ensemble",
      },
    },
    team: {
      kicker: "Il team",
      title: "Le persone dietro il sipario.",
      members: [
        {
          name: "Stefano Ongaro",
          role: "Titolare · Direttore Artistico · Responsabile Informatico",
        },
        {
          name: "Lucia Porri",
          role: "Direttore Musicale · Proscenio Wedding",
        },
        {
          name: "Tecnico Assistente",
          role: "Assistenza informatica & digitale",
        },
      ],
    },
    contact: {
      kicker: "Contatti",
      title: "Parliamone.",
      subtitle:
        "Scrivici per un preventivo, una consulenza o per conoscerci meglio. Rispondiamo sempre.",
      form: {
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono (opzionale)",
        subject: "Oggetto",
        area_label: "Ambito",
        area_options: {
          musica: "Musica",
          informatica: "Informatica",
          didattica: "Didattica",
          wedding: "Proscenio Wedding",
          ensemble: "Proscenio Ensemble",
          altro: "Altro",
        },
        message: "Il tuo messaggio",
        submit: "Invia messaggio",
        sending: "Invio in corso…",
        success: "Messaggio inviato. Ti risponderemo a breve.",
        error: "Ops, qualcosa è andato storto. Riprova.",
        validation: "Compila i campi obbligatori.",
      },
      info: {
        address_label: "Sede",
        address_value: "Piazza Mazzini 13, Ro — Riva del Po (FE)",
        hours_label: "Orari",
        hours_value:
          "Lun–Ven 15:00–19:00 · Sab 08:30–12:30 · Mattine su appuntamento",
        phone_label: "Telefono",
        email_label: "Email",
      },
    },
    footer: {
      rights: "Tutti i diritti riservati.",
      tagline: "Musica · Informatica · Didattica",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      brands: "Brands",
      team: "Team",
      contact: "Contact",
    },
    hero: {
      eyebrow: "PROSCENIO SOLUTIONS",
      title: "A stage full of solutions.",
      subtitle:
        "Music, IT and education — one artistic direction behind events, projects and people across the Ferrara and Rovigo provinces.",
      cta_primary: "Explore services",
      cta_secondary: "Get in touch",
      scroll: "Scroll",
    },
    marquee: ["Music", "IT", "Education", "Concerts", "Weddings", "Digital ID", "Training"],
    about: {
      kicker: "About",
      title: "Proscenio Solutions by Stefano Ongaro",
      body1:
        "A leading activity across the Ferrara and Rovigo provinces, we build our reputation on lasting relationships with our clients. We believe every client deserves high-level service — and that is exactly what we deliver.",
      body2:
        "Stefano Ongaro, founder, is a teacher and musician with decades of experience; he is also a certified IT specialist and officially authorized to verify personal identity for Italian SPID digital identity activation.",
      stat1_value: "20+",
      stat1_label: "Years of experience",
      stat2_value: "2",
      stat2_label: "Artistic brands",
      stat3_value: "3",
      stat3_label: "Service areas",
    },
    pillars: {
      kicker: "What we do",
      title: "Three souls, one craft.",
      music: {
        name: "Music",
        desc: "Concert organization, artistic direction and promotion of musical ensembles for events and ceremonies of every kind.",
        tags: ["Concerts", "Artistic direction", "Ceremonies"],
      },
      it: {
        name: "IT",
        desc: "IT support, consulting and authorized activation of the Italian SPID digital identity.",
        tags: ["Support", "SPID", "Digital ID"],
      },
      education: {
        name: "Education",
        desc: "Music-teaching projects and academic tutoring, with special care for students with learning disabilities (DSA / BES).",
        tags: ["Music teaching", "Tutoring", "DSA / BES"],
      },
    },
    brands: {
      kicker: "Our brands",
      title: "Curated by Proscenio Solutions.",
      wedding: {
        name: "Proscenio Wedding",
        role: "Ceremonies & receptions",
        desc: "The musical side of all kinds of events: religious and civil weddings, banquets, receptions. Ensembles from soloist to orchestra, tailor-made with our music planners.",
        cta: "Explore Wedding",
      },
      ensemble: {
        name: "Proscenio Ensemble",
        role: "Concert formation",
        desc: "Our concert ensemble, artistically directed by Stefano Ongaro. A repertoire spanning classical to contemporary, with a distinctive theatrical identity.",
        cta: "Explore Ensemble",
      },
    },
    team: {
      kicker: "Team",
      title: "The people behind the curtain.",
      members: [
        {
          name: "Stefano Ongaro",
          role: "Founder · Artistic Director · Head of IT",
        },
        {
          name: "Lucia Porri",
          role: "Musical Director · Proscenio Wedding",
        },
        {
          name: "IT Assistant",
          role: "IT & digital support",
        },
      ],
    },
    contact: {
      kicker: "Contact",
      title: "Let's talk.",
      subtitle:
        "Write us for a quote, a consultation or just to say hi. We always reply.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        subject: "Subject",
        area_label: "Area",
        area_options: {
          musica: "Music",
          informatica: "IT",
          didattica: "Education",
          wedding: "Proscenio Wedding",
          ensemble: "Proscenio Ensemble",
          altro: "Other",
        },
        message: "Your message",
        submit: "Send message",
        sending: "Sending…",
        success: "Message sent. We'll get back to you soon.",
        error: "Oops, something went wrong. Please try again.",
        validation: "Please fill in the required fields.",
      },
      info: {
        address_label: "Office",
        address_value: "Piazza Mazzini 13, Ro — Riva del Po (FE), Italy",
        hours_label: "Hours",
        hours_value:
          "Mon–Fri 3pm–7pm · Sat 8:30am–12:30pm · Mornings by appointment",
        phone_label: "Phone",
        email_label: "Email",
      },
    },
    footer: {
      rights: "All rights reserved.",
      tagline: "Music · IT · Education",
    },
  },
};
